import useDemoHelper from "./useDemoHelper";
import step81 from "../../../../../assets/demo/emergency/8.1.mp3";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const flashPictureBefore = () => {
        demoHelper.flash('[data-test="button-emergency-picture"]', 5);
    }


    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 8 seconds
            window.sound.src = step81;
            window.sound.play();

            await demoHelper.sleep(2000);

            flashPictureBefore();

            demoHelper.unlockInteract();
        }
    }
}